import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import * as React from 'react';
import classNames from 'classnames';
import cloneDeep from 'lodash/cloneDeep';
import Button from '../button';
import Icon from '../icon';
import Input from '../input';
import Dropdown from '../dropdown';
import Select from '../select';
import Option from '../select/option';

var SchemeFilter = function SchemeFilter(props) {
  var _context, _context5;

  var value = props.value,
      prefixCls = props.prefixCls,
      fields = props.fields,
      FilterLangMsg = props.FilterLangMsg,
      onSchemeSearch = props.onSchemeSearch,
      onSchemeSave = props.onSchemeSave,
      getSchemeSettingMenu = props.getSchemeSettingMenu;

  var _React$useState = React.useState(props.schemes || []),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      schemes = _React$useState2[0],
      setSchemes = _React$useState2[1];

  React.useEffect(function () {
    props.schemes !== undefined && setSchemes(props.schemes);
  }, [props.schemes]);

  var defaultItems = _mapInstanceProperty(_context = _filterInstanceProperty(fields).call(fields, function (_ref) {
    var required = _ref.required;
    return required;
  })).call(_context, function (_ref2) {
    var name = _ref2.name,
        operators = _ref2.operators,
        assignOptions = _ref2.assignOptions;

    var _a;

    var operator = operators === null || operators === void 0 ? void 0 : operators.props.defaultValue;
    var defaultValue = (_a = assignOptions[operator] || assignOptions.default) === null || _a === void 0 ? void 0 : _a.props.defaultValue;
    return {
      operator: operator,
      fieldName: name,
      required: true,
      value: defaultValue
    };
  });

  var defaultScheme = {
    name: '',
    items: defaultItems
  };

  var _React$useState3 = React.useState(value.scheme || defaultScheme),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      scheme = _React$useState4[0],
      setScheme = _React$useState4[1];

  React.useEffect(function () {
    var _context2;

    var nextScheme = cloneDeep(value.scheme || defaultScheme);
    nextScheme.items = _mapInstanceProperty(_context2 = nextScheme.items).call(_context2, function (item) {
      var field = _findInstanceProperty(fields).call(fields, function (_ref3) {
        var name = _ref3.name;
        return name === item.fieldName;
      });

      item.required = field === null || field === void 0 ? void 0 : field.required;
      return item;
    });
    setScheme(nextScheme); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  React.useEffect(function () {
    var nextScheme = _findInstanceProperty(schemes).call(schemes, function (_ref4) {
      var name = _ref4.name;
      return name === scheme.name;
    });

    if (!nextScheme && value.scheme) {
      setScheme(defaultScheme);
      onSchemeSearch && onSchemeSearch(defaultScheme);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [schemes]);

  var handleSwitchScheme = function handleSwitchScheme(name) {
    var _context3;

    var nextScheme = cloneDeep(_findInstanceProperty(schemes).call(schemes, function (scheme) {
      return name === scheme.name;
    }));
    nextScheme.items = _mapInstanceProperty(_context3 = nextScheme.items).call(_context3, function (item) {
      var field = _findInstanceProperty(fields).call(fields, function (_ref5) {
        var name = _ref5.name;
        return name === item.fieldName;
      });

      if (field === null || field === void 0 ? void 0 : field.required) item.required = field === null || field === void 0 ? void 0 : field.required;
      return item;
    });
    setScheme(nextScheme);
    onSchemeSearch && onSchemeSearch(nextScheme);
  };

  var handleAddCondition = function handleAddCondition() {
    var _a;

    if (fields.length) {
      var nextScheme = cloneDeep(scheme);

      var _fields$filter$ = _filterInstanceProperty(fields).call(fields, function (_ref6) {
        var required = _ref6.required;
        return !required;
      })[0],
          fieldName = _fields$filter$.name,
          operators = _fields$filter$.operators,
          assignOptions = _fields$filter$.assignOptions;

      var operator = operators === null || operators === void 0 ? void 0 : operators.props.defaultValue;
      var defaultValue = (_a = assignOptions[operator] || assignOptions.default) === null || _a === void 0 ? void 0 : _a.props.defaultValue;
      nextScheme.items.push({
        operator: operator,
        fieldName: fieldName,
        value: defaultValue
      });
      setScheme(nextScheme);
    }
  };

  var handleDeleteCondition = function handleDeleteCondition(index) {
    var _context4;

    var nextScheme = cloneDeep(scheme);

    _spliceInstanceProperty(_context4 = nextScheme.items).call(_context4, index, 1);

    setScheme(nextScheme);
  };

  var handleChangeField = function handleChangeField(index, fieldName) {
    var _a;

    var nextScheme = cloneDeep(scheme);

    var _fields$find = _findInstanceProperty(fields).call(fields, function (_ref7) {
      var name = _ref7.name;
      return name === fieldName;
    }),
        operators = _fields$find.operators,
        assignOptions = _fields$find.assignOptions;

    var operator = operators === null || operators === void 0 ? void 0 : operators.props.defaultValue;
    var defaultValue = (_a = assignOptions[operator] || assignOptions.default) === null || _a === void 0 ? void 0 : _a.props.defaultValue;
    nextScheme.items[index] = {
      operator: operator,
      fieldName: fieldName,
      value: defaultValue
    }; // debugger

    setScheme(nextScheme);
  };

  var handleChangeOperator = function handleChangeOperator(index, assignOptions, operator) {
    var _a;

    var nextScheme = cloneDeep(scheme);
    var defaultValue = (_a = assignOptions[operator] || assignOptions.default) === null || _a === void 0 ? void 0 : _a.props.defaultValue;
    nextScheme.items[index] = _extends(_extends({}, nextScheme.items[index]), {
      operator: operator,
      value: defaultValue
    });
    setScheme(nextScheme);
  };

  var handleChangeOption = function handleChangeOption(index, value) {
    var nextScheme = cloneDeep(scheme);
    nextScheme.items[index] = _extends(_extends({}, nextScheme.items[index]), {
      value: value
    });
    setScheme(nextScheme);
  };

  var handleChangeSchemeName = function handleChangeSchemeName(e) {
    var nextScheme = cloneDeep(scheme);
    nextScheme.name = e.target.value;
    setScheme(nextScheme);
  };

  var handleSearch = function handleSearch() {
    onSchemeSearch && onSchemeSearch(scheme);
  };

  var SettingMenu = getSchemeSettingMenu && getSchemeSettingMenu(scheme);
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames("".concat(prefixCls, "-body-scheme"), {
      active: props.tab === 'scheme'
    })
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-body-scheme-label")
  }, FilterLangMsg.commonScheme, ":"), /*#__PURE__*/React.createElement("ol", {
    className: "".concat(prefixCls, "-body-scheme-list")
  }, _mapInstanceProperty(schemes).call(schemes, function (_ref8) {
    var name = _ref8.name;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      React.createElement("li", {
        key: name,
        className: classNames("".concat(prefixCls, "-body-scheme-item"), {
          active: name === scheme.name
        }),
        onClick: handleSwitchScheme.bind(null, name)
      }, name)
    );
  })), SettingMenu && scheme.name && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-body-scheme-action")
  }, /*#__PURE__*/React.createElement(Dropdown, {
    menu: SettingMenu,
    trigger: "click",
    placement: "bottomRight"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "ghost",
    size: "small"
  }, FilterLangMsg.settings)))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-body-scheme-label")
  }, FilterLangMsg.advancedQuery, "\uFF1A"), /*#__PURE__*/React.createElement("ol", {
    className: "".concat(prefixCls, "-body-scheme-detail")
  }, _mapInstanceProperty(_context5 = scheme.items).call(_context5, function (_ref9, index) {
    var fieldName = _ref9.fieldName,
        operator = _ref9.operator,
        value = _ref9.value,
        required = _ref9.required;

    var field = _findInstanceProperty(fields).call(fields, function (_ref10) {
      var name = _ref10.name;
      return name === fieldName;
    });

    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-body-scheme-detail-field")
    }, required ? field === null || field === void 0 ? void 0 : field.label : /*#__PURE__*/React.createElement(Select, {
      borderType: "bordered",
      style: {
        width: '100%'
      },
      value: fieldName,
      onChange: handleChangeField.bind(null, index)
    }, _mapInstanceProperty(fields).call(fields, function (_ref11) {
      var name = _ref11.name,
          label = _ref11.label;
      return /*#__PURE__*/React.createElement(Option, {
        key: name,
        value: name,
        title: label
      }, label);
    }))), /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-body-scheme-detail-operator")
    }, (field === null || field === void 0 ? void 0 : field.operators) && /*#__PURE__*/React.cloneElement(field.operators, {
      value: operator,
      style: {
        width: '100%'
      },
      onChange: handleChangeOperator.bind(null, index, field.assignOptions)
    })), /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-body-scheme-detail-value")
    }, (field === null || field === void 0 ? void 0 : field.assignOptions) && /*#__PURE__*/React.cloneElement(field.assignOptions[operator] || field.assignOptions.default, {
      value: value,
      style: {
        width: '100%'
      },
      onChange: handleChangeOption.bind(null, index)
    })), /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-body-scheme-detail-and")
    }, FilterLangMsg.and), !required && /*#__PURE__*/React.createElement("span", {
      className: "".concat(prefixCls, "-body-scheme-detail-delete"),
      onClick: handleDeleteCondition.bind(null, index)
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "close-solid"
    })));
  }), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    ghost: true,
    size: "small",
    onClick: handleAddCondition
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "add",
    style: {
      verticalAlign: 'top',
      marginRight: 5
    }
  }), FilterLangMsg.addCondition)))), onSchemeSave && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-body-scheme-label")
  }, FilterLangMsg.schemeName, "\uFF1A"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-body-scheme-edit")
  }, /*#__PURE__*/React.createElement(Input, {
    borderType: "bordered",
    placeholder: FilterLangMsg.schemeNamePlaceholder,
    style: {
      width: 200
    },
    value: scheme.name,
    onChange: handleChangeSchemeName
  }), /*#__PURE__*/React.createElement(Button, {
    type: "ghost",
    style: {
      marginLeft: 12
    },
    onClick: onSchemeSave.bind(null, scheme)
  }, FilterLangMsg.saveScheme)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-body-scheme-action")
  }, /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    onClick: handleSearch
  }, FilterLangMsg.query))));
};

export default SchemeFilter;